import { render, staticRenderFns } from "./CreateNewCardCustomPicker.vue?vue&type=template&id=b836e064&scoped=true"
import script from "./CreateNewCardCustomPicker.vue?vue&type=script&lang=js"
export * from "./CreateNewCardCustomPicker.vue?vue&type=script&lang=js"
import style0 from "./CreateNewCardCustomPicker.vue?vue&type=style&index=0&id=b836e064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b836e064",
  null
  
)

export default component.exports